export enum AuctionLotSearchSortType {
    Default = 0,
    /** Unit Price (Low to High) */
    UnitPriceAscending = 1,
    /** Unit Price (High to Low) */
    UnitPriceDescending = 2,
    /** Max Bid (High to Low) */
    MaxBid = 3,
    /** Low Number (Low to High) */
    LotNumber = 4,
    /** Vintage (Old to New) */
    VintageAscending = 5,
    /** Vintage (New to Old) */
    VintageDescending = 6,
    /** Winery (A to Z) */
    WineryAscending = 7,
    /** Winery (Z to A) */
    WineryDescending = 8,
}
